import { createApiCall } from 'lib/base';

interface EditFundEcontractBody {}

const EDIT_FUND_ECONTRACT = 'EDIT_FUND_ECONTRACT';

export const editFundEcontractApi = createApiCall<
  EditFundEcontractBody & { id: string; payload: any }
>(EDIT_FUND_ECONTRACT, ({ id, payload }) => ({
  endpoint: `api/admin/fund-econtracts/${id}`,
  method: 'PUT',
  body: payload,
}));

export default editFundEcontractApi;
